import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../../toolkit/uicomponentcss";
import { Colors } from "../../../../../../utils/resources/colors";
import { Fonts } from "../../../../../../utils/resources/fonts";

export interface MemberDetailsRowCSSStyle extends UIComponentCSSStyle
{

    getHeader1DivCSSStyle():object;
    getHeader2DivCSSStyle():object;
    getTitleLabelCSSStyle():object;
    getTimestampDivCSSStyle():object;
    getTitleDivCSSStyle():object;
    getTimestampLabelCSSStyle():object;
}

export class  MemberDetailsRowCSSStyleImpl extends UIComponentCSSStyleImpl implements MemberDetailsRowCSSStyle
{
    
    getWrapperCSSStyle(): object
    {
        return {
            display: "flex",
            marginBottom:'20px',
            flexFlow: "row wrap",
            flexDirection:'row',
  
        };
    }

      getHeader1DivCSSStyle():object
      {
          return{
            height:'20px',
            lineHeight:'20px',
            fontWeight: "300",
            color:this.getResources().getColor(Colors.color_7),
            textAlign:"left",
            fontSize:this.getResources().getFont(Fonts.h7)
          };
      }

      getHeader2DivCSSStyle():object
      {
          return{
            color:this.getResources().getColor(Colors.color_25)
          };
      }
      getTitleDivCSSStyle():object
      {
          return{
              height:'20px', textAlign:'left',display:'flex'
              
          };
      }
  
      getTimestampDivCSSStyle():object
      {
          return{
              height:'20px', textAlign:'left',display:'flex' 
          };
      }

      getTitleLabelCSSStyle():object
    {
        return{
            color:'#221E20',
             minWidth:'60px',
              margin:'30px 0px 30px 5px', 
              fontFamily:this.getResources().getFontFamily(), 
              letterSpacing:'0', 
              height:'20px',
              lineHeight:'20px',
              overflow: 'hidden',
              textOverflow: 'ellipsis', 
              fontSize:'15px'
        };
    }

    getTimestampLabelCSSStyle():object
    {
        return{
            color:'#221E20',
            minWidth: "60px", 
            margin:'30px 10px 30px 0px', 
            fontFamily:this.getResources().getFontFamily(), 
            letterSpacing:'0',
            height:'20px',
            lineHeight:'20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis', 
            fontSize:'15px'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/membersdetails/memberdetailsrowcss.tsx